import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import apiInstance from '../../api/api';
import {showNotification} from "../notification/notificationSlice";
import {handleAxiosError} from "../../utils/axiosErrorHandler";
import {ApiFailResponse} from "../../utils/interfaces/apiTypes";
import apiEndpoints from '../../utils/api/endpoints';

export interface Ncp2026PayloadProps {
    magazin: string;
    birthdate: string;
    firstname: string;
    lastname: string;
    phone: string;
    receiptNr: string;
    receiptDate: string;
    receiptFile: string;
}

export interface Ncp2026StateProps {
    loading: boolean;
    error: string | null;
}

const initialState: Ncp2026StateProps = {
    loading: false,
    error: null,
}

export const insertNcp2026 = createAsyncThunk(
    'ncp2026/insertNcp2026',
    async (payload: Ncp2026PayloadProps, thunkAPI) => {
        try{
            const response = await apiInstance.post(apiEndpoints.ncp2026Insert, payload);
            thunkAPI.dispatch(showNotification({message: response.data.data['message'], variant: 'success'}));

            return response.data;
        } catch (error: any) {
            const errorData = handleAxiosError(error) as ApiFailResponse;
            return thunkAPI.rejectWithValue(errorData);
        }
    }
);

const ncp2026Slice = createSlice({
    name: "ncp2026",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(insertNcp2026.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(insertNcp2026.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(insertNcp2026.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload ? (action.payload as ApiFailResponse).message : 'A apărut o eroare';
            })
        ;
    }
});

export const { clearError } = ncp2026Slice.actions;
export default ncp2026Slice.reducer;